import React from "react";
import styles from "./QuoteTableSkeletonLoader.module.scss";
import cx from "classnames";

interface IQuoteTableSkeletonLoaderCell {
    isHighlighted?: boolean;
}

const QuoteTableSkeletonLoaderCell: React.FC<IQuoteTableSkeletonLoaderCell> = React.memo(
    (props) => {
        return (
            <div
                className={cx([
                    styles["basic-panel"],
                    {
                        [styles["is-highlighted"]]: props.isHighlighted
                    }
                ])}>
                {/* Premium */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-xl",
                        styles["anim-cell-height-5"],
                        styles["anim-cell-width-13_5"]
                    )}
                />
                {/* Price breakdown */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-ml",
                        styles["anim-cell-height-1"],
                        styles["anim-cell-width-20"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-s",
                        styles["anim-cell-height-1"],
                        styles["anim-cell-width-11"]
                    )}
                />
                {/* Cashback */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-2xl",
                        styles["anim-cell-height-3_5"],
                        styles["anim-cell-width-9"]
                    )}
                />
                {/* Logo */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-xl",
                        styles["anim-cell-height-4"],
                        styles["anim-cell-width-13_5"]
                    )}
                />
                {/* Apply Now */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-l",
                        styles["anim-cell-height-4_5"]
                    )}
                />
                {/* Offers and Benefits */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-ml",
                        styles["anim-cell-height-20"]
                    )}
                />
                {/* View Details */}
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-ml",
                        styles["anim-cell-height-4_5"]
                    )}
                />
            </div>
        );
    }
);

QuoteTableSkeletonLoaderCell.displayName = "QuoteTableSkeletonLoaderCell";

export default React.memo(QuoteTableSkeletonLoaderCell);
